// src/app/pages/admin/exam_applicants/rtAdExamApplicants.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const ExamApplicants = Loadable(lazy(() => import("./ExamApplicants")));

const routes = Object.values(EXAM_TYPES).map(examType => ({
  path: `${examType.pathPrefix}/exam-applicants`,
  element: <ExamApplicants />
}));

export default routes;